import { useCurrency } from '@shared/selectors/globalSelectors';
import React from 'react';

export default function FlatRate({ data }: { data: any }) {
  const rateValue = data?.[0]?.rate ?? data?.rate ?? data?.fixed ?? data?.[0]?.fixed ?? 'N/A';
  const unit = data?.[0]?.unit ?? data?.unit ?? 'NA';
  const currency = useCurrency();
  return (
    <div className="flex items-baseline gap-1.5 mt-2">
      <div className="text-lg font-semibold text-slate-900">
        {currency} {rateValue} <span className="text-slate-400 font-normal">/</span>
      </div>
      <div className="text-sm font-medium text-slate-500">{unit}</div>
    </div>
  );
}
